<template>
  <div>
    <Dialog
      width="800px"
      :height="createRenderType == 'mobile' ? '700px' : '695px'"
      titleAlign="left"
      :title="$$t('create.prompt')"
      :subTitle="$$t('create.add_prompt')"
      :visible="renderData.visible"
      @close="onClose"
      mobileRenderType="drawerDialog"
    >
      <div
        class="add-music-discribe height-all flex-column"
        :class="`add-music-discribe--${createRenderType}`"
      >
        <div class="add-music-discribe-edit flex1 height-0">
          <div
            class="add-music-discribe-input-box flex"
            :class="{
              'idea-edit-mode': renderData.editMode,
            }"
          >
            <div class="add-music-discribe-input">
              <textarea
                ref="refInput"
                :placeholder="$$t('create.prompt_placehoder')"
                :value="renderData.idea"
                @input="handleInput"
                @change="handleChange"
                @blur="handleBlur"
                @focus="handleFocus"
                @compositionstart="handleCompositionStart"
                @compositionend="handleCompositionEnd"
              ></textarea>
            </div>
            <div class="add-music-discribe-input-bottom">
              <div
                class="add-music-discribe-input-count"
                :class="{
                  'add-music-discribe-input-count-error':
                    renderData.ideaCount >= MAX_PROMPT_COUNT,
                }"
              >
                {{ `${renderData.ideaCount} / ${MAX_PROMPT_COUNT}` }}
              </div>
              <div class="add-music-discribe-input-random-box">
                <RandomTagRefer
                  :disabled="renderData.ideaCount >= MAX_PROMPT_COUNT"
                  :loading="renderData.randomLoading"
                  :randomTags="renderData.describes"
                  @randomClick="onRandomClick"
                  @addMusicDiscribe="addMusicDiscribe"
                >
                </RandomTagRefer>
              </div>
            </div>
          </div>

          <!-- <div class="add-music-discribe-ideas-box flex">
            <div
              class="add-music-discribe-ideas-random pointer"
              :class="{
                'add-music-discribe-ideas-random-loading':
                  renderData.randomBatchLoading,
              }"
              @click="onRandomBatchClick"
              v-if="createRenderType != 'mobile'"
            >
              <i></i>
              <span>{{ $$t("create.change_batches") }}</span>
            </div>
            <div class="add-music-discribe-ideas-list flex1">
              <div
                class="add-music-discribe-ideas-random pointer fn-inline"
                :class="{
                  'add-music-discribe-ideas-random-loading':
                    renderData.randomBatchLoading,
                }"
                v-if="createRenderType == 'mobile'"
                @click="onRandomBatchClick"
              >
                <div class="flex-center wh100">
                  <i></i>
                  <span>{{ $$t("create.change_batches") }}</span>
                </div>
              </div>
              <template
                v-for="(item, index) in renderData.describes"
                :key="item"
              >
                <div
                  class="add-music-discribe-ideas-list-item fn-inline pointer olh"
                  v-if="item.show"
                  :class="{
                    'fadewidtheasinout-enter-active': item.show,
                    'fadewidtheasinout-leave-active': !item.show,
                  }"
                  @click="
                    () => {
                      addMusicDiscribe(item, index);
                    }
                  "
                >
                  {{ item.content }}
                </div>
              </template>
            </div>
          </div> -->
          <div class="add-music-discribe-type-ideas-box">
            <div class="add-music-discribe-type-ideas-item">
              <TagRefer
                v-if="typeTagDataMap?.genres"
                :title="$$t('create.genre')"
                :idea="renderData.idea"
                :tagList="typeTagDataMap?.genres ?? []"
                @referTagSelect="onReferTagSelect"
              ></TagRefer>
            </div>
            <div class="add-music-discribe-type-ideas-item">
              <TagRefer
                v-if="typeTagDataMap?.moods"
                :title="$$t('create.mood')"
                :idea="renderData.idea"
                :tagList="typeTagDataMap?.moods ?? []"
                @referTagSelect="onReferTagSelect"
              ></TagRefer>
            </div>
            <div class="add-music-discribe-type-ideas-item">
              <TagRefer
                v-if="typeTagDataMap?.vocals"
                :title="$$t('create.vocal_gender')"
                :idea="renderData.idea"
                :tagList="typeTagDataMap?.vocals ?? []"
                @referTagSelect="onReferTagSelect"
              ></TagRefer>
            </div>
          </div>
        </div>

        <div class="add-music-discribe-done-btn-box">
          <div class="add-music-discribe-done-btn">
            <Button
              @click="onDoneClick"
              :renderStyle="{
                '--padding': '0',
                '--width': '100%',
                '--height': '48px',
                '--borderRadius': '50px',
                '--fontColor': '#000',
                '--fontSize': '16px',
                '--fontWeight': 'normal',
                '--border': 'none',
                '--background':
                  'linear-gradient(120deg, rgb(79, 222, 255, 1) -1%, rgb(230, 117, 255, 1) 100%)', //#94ADFF
                '--backgroundHover':
                  'linear-gradient(120deg, rgb(79, 222, 255, 0.75) -1%, rgb(230, 117, 255, 0.75) 100%)',
                '--fontColorHover': '#000',
              }"
            >
              {{ $$t("create.done") }}
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue"
import globalConfig from "@/config/config.js"

import { useRouter, useRoute } from "vue-router"
import Dialog from "@/components/basic/dialog/Dialog.vue"
import Button from "@/components/basic/button/Button.vue"
import IconButton from "@/components/basic/button/IconButton.vue"
import TagRefer from "./tagRefer.vue"
import RandomTagRefer from "./randomTagRefer.vue"
import feedListApi from "@/api/api/feedListApi.js"
import message from "@/components/functionCallComponent/message.jsx"

import tools from "@/utils/tools.js"
import { storeToRefs } from "pinia"
import useUserDataStore from "@/store/userDataStore.js"
const userDataStore = useUserDataStore()
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
const createLayoutStore = useCreateLayoutStore()
const { createRenderType } = storeToRefs(createLayoutStore)
import usePromptDataStore from "@/store/create/promptDataStore.js"
const promptDataStore = usePromptDataStore()

const { typeTagDataMap } = storeToRefs(promptDataStore)

const globalProperties = (
  getCurrentInstance() || window?.$getVueCurrentInstance?.()
).appContext?.config?.globalProperties
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const MAX_PROMPT_COUNT = tools.isDev() ? 1000 : 300
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
})
const emits = defineEmits([
  "update:visible",
  "apply",
  "input",
  "blur",
  "change",
  "focus",
])

// const discribeData = Array.from({ length: 15 }, (_, i) => `换一批${i}`);

//
const stateData = {
  separatorReg: `，。、；！？‘【】、=-·~！@#￥%……&*（）——+「」“”：》!?,./;'[]\=-)(*&^%$#@!~>?:"{}|｜¥~～·`,
  separator: $$language() == "cn" ? "，" : ", ",
}

const refInput = ref(null)

const renderData = reactive({
  randomLoading: false,
  randomBatchLoading: false,
  visible: props.visible,
  idea: "",
  editMode: false,
  ideaCount: 0,
  describes: [],
  hasAddDatas: [],
})

const onClose = () => {
  renderData.visible = false
}

const handleCompositionStart = () => {
  renderData.inputing = true
}

const handleCompositionEnd = (e) => {
  renderData.inputing = false
  handleInput(e)
}
const handleInput = (e) => {
  if (!renderData.inputing) {
    e.target.value = e.target.value.slice(0, MAX_PROMPT_COUNT)
    renderData.idea = e.target.value
    if (!renderData.idea?.replace(/ {0,}\n{0,}/g, "")) {
      promptDataStore.deleteRecommendPromptPresetData()
    } else {
      handleInputChangeDebounceCall()
    }
    emits("input", renderData.idea)
  }
}

const handleBlur = (e) => {
  renderData.editMode = false
  emits("blur", renderData.idea)
}

const handleFocus = (e) => {
  renderData.editMode = true
  emits("focus", renderData.idea)
}

const handleChange = (e) => {
  renderData.ideaCount = renderData.idea.length
  emits("change", renderData.idea)
  // onRandomBatchClick(false);
}

const setAddRenderIdea = (data) => {
  data = data ?? ""
  if (!renderData.idea?.replace(/ {0,}\n{0,}/g, "")) {
    renderData.idea = renderData.idea + data
  } else {
    if (
      stateData.separatorReg.includes(
        renderData.idea.replace(/ +\n+/g, "").slice(-1)
      )
    ) {
      if (renderData.idea?.endsWith(" ")) {
        renderData.idea = renderData.idea + data
      } else {
        renderData.idea = renderData.idea + " " + data
      }
    } else {
      if (/( {1,}|\n{1,})$/.test(renderData.idea)) {
        renderData.idea = renderData.idea + data
      } else {
        renderData.idea = renderData.idea + stateData.separator + data
      }
    }
  }

  if (renderData.idea?.length > MAX_PROMPT_COUNT) {
    renderData.idea = renderData.idea?.slice(0, MAX_PROMPT_COUNT)
    return true
  } else {
    return false
  }
}

const addMusicDiscribe = (item, index) => {
  globalProperties?.logClickEvent("create_prompt_batch_recommend", {
    type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
    random: "true",
  })
  if (renderData.idea.length >= MAX_PROMPT_COUNT) {
    return
  }
  if (setAddRenderIdea(item.content)) {
  } else {
    renderData.hasAddDatas?.push(item.content)
  }

  // if (
  //   !renderData.describes?.some((it) => {
  //     if (
  //       !it.show &&
  //       it.type == item.type &&
  //       !renderData.hasAddDatas?.includes(it.content)
  //     ) {
  //       it.show = true;
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   })
  // ) {
  //   renderData.describes?.some((it) => {
  //     if (!it.show && !renderData.hasAddDatas?.includes(it.content)) {
  //       it.show = true;
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   });
  // }

  renderData.describes[index].show = false
  renderData.describes = renderData.describes
    ?.filter((it) => it.show)
    .concat(renderData.describes?.filter((it) => !it.show))
  promptDataStore.renderPresetData = renderData.describes
  promptDataStore.renderPresetDataHasAddData = renderData.hasAddDatas
  addMusicDiscribeAfter(item, index)
  handleChange()
  handleInputChangeDebounceCall()
}

const addMusicDiscribeAfter = (item, index) => {
  promptDataStore.promptPresetDataShow[item.type]?.splice(
    promptDataStore.promptPresetDataShow[item.type]?.indexOf(item.content),
    1
  )
  if (promptDataStore.promptPresetData[item.type]?.length) {
    let itemAdd = promptDataStore.promptPresetData[item.type]?.shift()
    promptDataStore.promptPresetDataShow[item.type]?.push(itemAdd)
  } else {
    Object.keys(promptDataStore.promptPresetDataShow).some((key) => {
      if (promptDataStore.promptPresetData[key]?.length) {
        let itemAdd = promptDataStore.promptPresetData[key]?.shift()
        promptDataStore.promptPresetDataShow[key]?.push(itemAdd)
        return true
      }
    })
  }
  promptDataStore.promptPresetDataShow = Object.assign(
    {},
    promptDataStore.promptPresetDataShow
  )
}

const onReferTagSelect = (item) => {
  let datas = renderData.idea?.split(stateData.separator.replace(/\s+/, ""))
  let idxs = []
  datas.forEach((str, idex) => {
    if (str.replace(/(^\s+)|(\s+$)/, "") == item.tag) {
      idxs.push(idex)
    }
  })
  if (idxs?.length) {
    datas = datas.filter((it, index) => !idxs.includes(index))
    renderData.idea = datas.join(stateData.separator.replace(/\s+/, ""))
    globalProperties?.logClickEvent("create_prompt_batch_recommend", {
      random: "false",
      option: "cancel",
      type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
    })
  } else if (setAddRenderIdea(item.tag)) {
    globalProperties?.logClickEvent("create_prompt_batch_recommend", {
      random: "false",
      option: "apply",
      type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
    })
  } else {
    globalProperties?.logClickEvent("create_prompt_batch_recommend", {
      random: "false",
      option: "apply",
      type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
    })
  }
  if (!renderData.idea?.replace(/ {0,}\n{0,}/g, "")) {
    promptDataStore.deleteRecommendPromptPresetData()
  } else {
    handleInputChangeDebounceCall()
  }
}

// const onRandomBatchClick = () => {
//   renderData.randomBatchLoading = true;
//   promptDataStore
//     .changebatchPromptPresetData({
//       prompt: renderData.idea,
//     })
//     .then((res) =>
//       renderData.randomBatchLoading = false;
//       // nextTick(() => {
//       //   refInput.value?.focus();
//       // });
//     })
//     .catch((err) => {
//       renderData.randomBatchLoading = false;
//     });
//   globalProperties?.logClickEvent("create_prompt_batch_random", {});
// };
const handleInputChangeDebounceCall = tools.debounce(() => {
  if (renderData.idea?.replace(/ {0,}\n{0,}/g, "")) {
    onRandomBatchClick(false)
  }
}, 800)

const onRandomBatchClick = (isClick = true) => {
  renderData.randomBatchLoading = isClick ? true : false
  let dataTime = new Date().getTime()
  renderData.changeRecommendPromptPresetDataTime = dataTime
  promptDataStore
    .changeRecommendPromptPresetData({
      prompt: renderData.idea,
    })
    .then((res) => {
      if (renderData.changeRecommendPromptPresetDataTime == dataTime) {
        renderData.randomBatchLoading = false
      }
      // nextTick(() => {
      //   refInput.value?.focus();
      // });
    })
    .catch((err) => {
      if (renderData.changeRecommendPromptPresetDataTime == dataTime) {
        renderData.randomBatchLoading = false
      }
    })
}

const onRandomClick = () => {
  globalProperties?.logClickEvent("create_prompt_random", {
    tab_stare: "advanced_description",
    type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
  })
  if (renderData.idea.length >= MAX_PROMPT_COUNT) return
  renderData.randomLoading = true
  feedListApi
    .getPromptRandomData({
      // prompt: renderData.idea,
      last_id: promptDataStore.lastRandomPromptId,
    })
    .then((res) => {
      renderData.randomLoading = false
      if (res.code == 200) {
        promptDataStore.lastRandomPromptId = res.data?.prompt?.id
        renderData.idea =
          res.data.prompt?.content?.slice(0, MAX_PROMPT_COUNT) ?? ""
        // if (setAddRenderIdea(res.data.prompt?.content)) {
        //   return;
        // }
        // nextTick(() => {
        //   refInput.value?.focus();
        // });
      }
    })
    .catch((err) => {
      renderData.randomLoading = false
    })
}

const checkLanguage = (str) => {
  return new Promise((resolve, reject) => {
    if (!globalConfig.switchLanguage) {
      resolve()
      return
    }
    const closeMsg = message.loading({
      content: $$t("create.applying"),
    })
    return feedListApi
      .queryLanguageDetect({
        text: str,
      })
      .then((res) => {
        closeMsg.clear()
        if (res.code == 200) {
          resolve()
        } else if (res.code == 6340) {
          message.error({
            content: $$t("create.not_generate_because_not_support_language"),
          })
          reject($$t("create.not_generate_because_not_support_language"))
        } else {
          message.error({
            content: $$t("create.check_support_language_error"),
          })
          reject("check_support_language_error")
        }
      })
      .catch((err) => {
        closeMsg.clear()
        message.error({
          content: $$t("create.check_support_language_error"),
        })
        reject(err)
      })
  })
}

const onDoneClick = () => {
  const regex =
    /[a-zA-Z0-9\u4E00-\u9FFF\uAC00-\uD7AF\u1100-\u11FF\u3130-\u318FÀ-ÖØ-öø-ÿ\u3040-\u309F\u30A0-\u30FFÁÉÍÓÚÜÑáéíóúüñ]+/i
  if (regex.test(renderData.idea)) {
    checkLanguage(renderData.idea)
      .then(() => {
        promptDataStore.setPromptDataContent(renderData.idea)
        emits("apply", true)
        onClose()
      })
      .catch((err) => {
        console.error("checkLanguage", err)
      })
  } else {
    emits("apply", false)
    promptDataStore.setPromptDataContent("")
    onClose()
  }
}

watch(
  () => {
    return promptDataStore.renderPresetData
  },
  () => {
    renderData.describes = promptDataStore.renderPresetData
    renderData.hasAddDatas = promptDataStore.renderPresetDataHasAddData
  }
)

watch(
  () => props.visible,
  (val) => {
    renderData.visible = props.visible
  }
)

watch(
  () => renderData.visible,
  (val) => {
    emits("update:visible", val)
  }
)
watch(
  () => renderData.idea,
  (val) => {
    renderData.ideaCount = val.length
  }
)
onMounted(() => {
  renderData.idea = promptDataStore.promptData?.content ?? ""
  promptDataStore.initPromptTypeTags()
  if (!renderData.idea) {
    // promptDataStore.getAllPromptPresetDatas({
    //   pompt: renderData.idea,
    // });
  } else {
    renderData.describes = promptDataStore.renderPresetData
    renderData.hasAddDatas = promptDataStore.renderPresetDataHasAddData
    // if (!renderData.describes.length) {
    //   onRandomClick();
    // }
  }
})
</script>
<style lang="scss">
@keyframes width-change {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes animationWidthFadeOut {
  0% {
    padding: 0 24px;
    width: unset;
    height: unset;
    opacity: 1;
  }
  100% {
    width: 0;
    padding: 0;
    height: 0;
    opacity: 0;
  }
}

@keyframes animationWidthFadeIn {
  0% {
    width: 0;
    padding: 0;
    height: 0;
    opacity: 0;
  }
  100% {
    padding: 0 24px;
    width: unset;
    height: unset;
    opacity: 1;
  }
}

.add-music-discribe {
  padding: 20px 40px 40px 40px;
  .add-music-discribe-input-box {
    position: relative;
    padding: 12px 16px;
    border-radius: 12px;
    background: rgba(148, 173, 255, 0.2);
    border: none;
    position: relative;
    border: 1px solid rgba(255, 255, 255, 0);
    flex-direction: column;
    .add-music-discribe-input {
      height: 100px;
    }
    &:hover {
      background: rgba(148, 173, 255, 0.2);
    }
    &.idea-edit-mode {
      border: 1px solid #94adff;
      &:hover {
        background: rgba(148, 173, 255, 0.2);
      }
      &:focus-within {
        background: rgba(148, 173, 255, 0.2);
      }
    }
    &.idea-edit-mode-active {
      background: rgba(148, 173, 255, 0.2);
    }
    &.idea-edit-mode-disabled {
      background: rgba(255, 255, 255, 0.1);
    }
    textarea {
      height: 100%;
      width: 100%;
      border: none;
      outline: none;
      resize: none;
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: normal;
      color: #ffffff;
      line-height: 24px;
      background-color: transparent;
      &::placeholder {
        color: rgba(255, 255, 255, 0.5) !important;
      }
    }

    .add-music-discribe-input-bottom {
      margin: 8px 0 0 0;
      align-items: end;
      justify-content: space-between;
      .add-music-discribe-input-random-box {
        margin: 8px 0 0 0;
      }
    }
    .add-music-discribe-input-count {
      font-family: HarmonyOS Sans SC;
      font-size: 12px;
      font-weight: 300;
      line-height: 20px;
      color: rgba(255, 255, 255, 0.5);
    }
    .add-music-discribe-input-count-error {
      color: #ff5f74;
    }
  }
  .add-music-discribe-edit {
    flex: 1 1 0;
    overflow-y: auto;
  }
  /*.add-music-discribe-ideas-box {
    margin: 32px 0 0 0;
    .add-music-discribe-ideas-random {
      height: 42px;
      padding: 0 24px;
      border-radius: 60px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      background: rgba(148, 173, 255, 0.5);
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: normal;
      color: #ffffff;
      width: max-content;
      i {
        width: 20px;
        height: 20px;
        background-image: url(@/assets/img/refresh-white-ico.png);
        background-size: 100%;
      }
      span {
        margin-left: 8px;
      }
      &:hover {
        background: rgba(148, 173, 255, 0.6);
      }
      &.add-music-discribe-ideas-random-loading {
        pointer-events: none;
        i {
          height: 20px;
          width: 20px;
          min-width: 20px;
          min-height: 20px;
          background-image: url(/src/assets/img/loading-mini-3x.png) !important;
          background-size: 100% 100% !important;
          animation: animation-rotate-infinite 0.75s infinite normal linear;
        }
      }
    }
    .add-music-discribe-ideas-list {
      margin: 0 0 0 24px;
      min-height: 162px;
      .add-music-discribe-ideas-random {
        display: inline-block;
        padding: 0;
        margin: 0 8px 8px 0;
        > div {
          padding: 0 20px;
        }
      }
      .add-music-discribe-ideas-list-item {
        margin: 0 8px 12px 0;
        line-height: 42px;
        border-radius: 50px;
        background: rgba(255, 255, 255, 0.2);
        font-family: HarmonyOS Sans SC;
        font-size: 16px;
        font-weight: normal;
        color: #ffffff;
        padding: 0 20px;
        width: unset;
        height: unset;
        opacity: 1;

        &:hover {
          background: rgba(255, 255, 255, 0.3);
        }
      }
    }
  }*/

  .add-music-discribe-type-ideas-box {
    .add-music-discribe-type-ideas-item {
      margin: 20px 0 0 0;
      height: 64px;
    }
  }

  .add-music-discribe-done-btn-box {
    margin: 32px 0 0 0;
    .add-music-discribe-done-btn {
      width: 400px;
      max-width: 100%;
      margin: 0 auto;
    }
  }
  &.add-music-discribe--mobile {
    padding: 16px;
    height: 100%;
    display: flex;
    flex-direction: column;
    .add-music-discribe-edit {
      display: flex;
      flex-direction: column;
    }
    .add-music-discribe-input-box {
      flex: 1 1 0;
      .add-music-discribe-input {
        min-height: 150px;
        flex: 1 1 0;
      }
    }
    /*.add-music-discribe-ideas-box {
      flex: 1 1 0;
      flex-direction: column;
      margin: 20px 0 0 0;
    }*/
    .add-music-discribe-ideas-random {
      margin: 0 8px 8px 0;
      height: 40px;
      > div {
        padding: 0 20px;
      }
    }
    .add-music-discribe-ideas-list {
      margin: 0 0 0 0;
      min-height: 210px;
      .add-music-discribe-ideas-list-item {
        margin: 0 8px 8px 0;
        height: 40px;
      }
    }
    .add-music-discribe-type-ideas-box {
      .add-music-discribe-type-ideas-item {
        margin: 16px 0 0 0;
      }
    }
    @media (max-width: 375) {
      .add-music-discribe-ideas-list {
        margin: 0 0 0 0;
        min-height: 240px;
        .add-music-discribe-ideas-list-item {
          margin: 0 8px 8px 0;
          height: 40px;
        }
      }
    }
    .add-music-discribe-done-btn-box {
      margin: 24px 0 0 0;
      .add-music-discribe-done-btn {
        width: 100%;
        max-width: 100%;
        margin: 0 auto;
      }
    }
  }
}
</style>
